import { SpacedComma, TruncatedText } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Chip, Container, Stack, StackItem } from '@optimus-web/core';

interface Props {
    items: string[];
    cutoff: number;
    lastMaxLength?: number;
}

export const SlicedItemListWithBadge = ({ items, cutoff, lastMaxLength = 5 }: Props) => {
    const displayedItems = items.slice(0, cutoff);
    const remainingItems = items.slice(cutoff);
    const peakedItem = items[cutoff];
    const remainingItemsLength = remainingItems.length;

    return (
        <Stack itemAlignment="center">
            <StackItem>
                {displayedItems.join(', ')}
                {remainingItemsLength > 0 && lastMaxLength > 0 ? (
                    <>
                        {SpacedComma}
                        <TruncatedText text={peakedItem} maxLength={lastMaxLength} />
                    </>
                ) : null}
            </StackItem>
            {remainingItemsLength > 0 ? (
                <Container padding={['0', '0', '0', '100']}>
                    <Chip data-test-id="collapsed-count-tag" showRemoveButton={false}>
                        {UnicodeEntity.PlusSign}
                        {remainingItemsLength}
                    </Chip>
                </Container>
            ) : null}
        </Stack>
    );
};
